<script>
  import formatDate from '@utils/format-date'

  export default {
    props: {
      data: {
        type: Object,
        required: true
      },
    },
    methods: {
      formatDate
    }
  }
</script>
<template>
  <div :class="$style.listSolutionItem">
    <div class="listSolutionItem__content">
      <div :class="$style.brandList">
        <router-link
          v-for="(item,$index) in data.brands"
          :key="$index"
          :to="{ name: 'brand-item', params: { brandAlias: item.alias } }"
          class="brandList__item "
        >
          <img
            :src="item.logo_image"
            :alt="item.title"
            class="brandList__logo"/>
        </router-link>
      </div>
      <div class="listSolutionItem__content__box d-flex flex-column">
        <div class="listSolutionItem__title">
          {{ data.title }}
        </div>
        <div class="listSolutionItem__date mt-auto">
          <i class="far fa-clock"></i>
          <template v-if="data.publish_up">
            {{ formatDate(data.publish_up) }}
          </template>
        </div>
      </div>
    </div>
    <router-link
      class="listSolutionItem__link"
      :to="data.to"
    >
    </router-link>
  </div>
</template>
<style lang="scss" module>
  .listSolutionItem {
    position: relative;
    background: #FFF;
    border-radius: 2px;
    box-shadow: $box-shadow-base;
    transition: box-shadow 0.3s;

    &:hover {
      box-shadow: $box-shadow-base-hover;

      :global {
        .listSolutionItem {
          &__title {
            color: $color-primary;
          }
        }
      }
    }

    .brandList {
      display: flex;
      align-items: center;
      height: 65px;

      @include max-md {
        height: 50px;
      }

      :global {
        .brandList {
          &__item {
            &:not(:last-child) {
              position: relative;
              padding-right: 20px;
              margin-right: 20px;

              &::after {
                position: absolute;
                top: 50%;
                right: 0;
                width: 1px;
                height: 40%;
                content: '';
                background: $color-gray-2;
                transform: translateY(-50%);
              }
            }

          }

          &__logo {
            // object-fit: contain;
            // object-position: center center;
            max-height: 55px;

            @include max-md {
              max-height: 45px;
            }
          }
        }

      }
    }

    :global {
      .listSolutionItem {
        &__content {
          padding: 1.875rem 3.125rem;

          @include max-md {
            padding: 1rem;
          }

          &__box {
            @include max-lg {
              margin-left: 0;
            }
          }
        }

        &__title {
          @include line-clamp(1, 1.5em);

          margin-bottom: 1.25rem;
          font-size: 1.5rem;
          font-weight: 500;
          line-height: 1.5;

          @include max-md {
            font-size: 1.25rem;
            @include line-clamp(2, 3.1em);
          }
        }

        &__date {
          font-size: 0.875rem;
          color: $color-gray-5;
        }

        &__link {
          position: absolute;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
        }
      }
    }
  }

  // .brandList {
  //   display: flex;
  //   margin-bottom: 1.25rem;

  //  /* @include max-md {
  //     display: none;
  //   } */
  //   :global {
  //     .brandList {
  //       &__item {
  //         position: relative;
  //         z-index: 1;
  //         .brandList__link {
  //           color: $color-gray-6;
  //         }
  //         &:not(:last-child) {
  //           .brandList {
  //             &__link {
  //               border-right: 1px solid $color-gray-3;
  //             }
  //           }
  //         }
  //         &:first-child {
  //           .brandList {
  //             &__link {
  //               padding-left: 0;
  //             }
  //           }
  //         }
  //       }
  //       &__link {
  //         // display: block;
  //         padding: 0 1.25rem;
  //         &:hover {
  //           opacity: 0.75;
  //         }
  //       }
  //       &__logo {
  //         max-height: 26px;
  //       }
  //     }
  //   }
  // }
</style>
